import { Injectable, inject } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { TransactionInfoModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): TransactionInfoModel {
  return <TransactionInfoModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-Transaction-store' })
export class Cmg1003TransactionStore extends Store<TransactionInfoModel> implements iStoreActions<TransactionInfoModel> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: TransactionInfoModel = null;
  constructor() {
    super(createInitialState());
  }

  override akitaPreUpdate = (transaction: Readonly<TransactionInfoModel>, updatedTransaction: TransactionInfoModel) => {
    if (updatedTransaction.borrowerClosingCosts && updatedTransaction.borrowerClosingCosts.length > 0) {
      updatedTransaction.borrowerClosingCost = (updatedTransaction.borrowerClosingCosts || []).reduce(
        (a, b) => ({
          amount: a.amount + b.amount,
        }),
        { amount: 0, description: null },
      ).amount;
    } else {
      updatedTransaction.borrowerClosingCost = 0.0;
    }
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return updatedTransaction;
  };

  preAdd = (transaction: TransactionInfoModel) => {
    if (!transaction) {
      return;
    }

    if (!transaction.discountPoints) {
      transaction.discountPoints = {
        borrowerAmount: undefined,
        ccId: undefined,
        gfeBlock: undefined,
        hudLineNo: undefined,
        hudLineNo2010: undefined,
        paidByOtherType: undefined,
        paidToType: undefined,
        points: undefined,
        sellerAmount: undefined,
        tridBlock: undefined,
      };
    }

    const discountPoints = transaction.discountPoints;
    if (discountPoints.borrowerAmount === null || typeof discountPoints.borrowerAmount === 'undefined') {
      discountPoints.borrowerAmount = null;
    }

    if (discountPoints.sellerAmount === null || typeof discountPoints.sellerAmount === 'undefined') {
      discountPoints.sellerAmount = null;
    }

    if (discountPoints.paidByOtherType === null || typeof discountPoints.paidByOtherType === 'undefined') {
      discountPoints.paidByOtherType = null;
    }

    if (discountPoints.points === null || typeof discountPoints.points === 'undefined') {
      discountPoints.points = null;
    }
  };

  preInitialize(transactionInfo: TransactionInfoModel): void {
    this.preAdd(transactionInfo);
    this.update(transactionInfo);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
